const moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(315), __webpack_require__.e(817), __webpack_require__.e(460), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(834), __webpack_require__.e(369), __webpack_require__.e(724), __webpack_require__.e(290), __webpack_require__.e(243), __webpack_require__.e(955)]).then(() => (() => ((__webpack_require__(35033)))));
	},
	"./Compare": () => {
		return Promise.all([__webpack_require__.e(315), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(834), __webpack_require__.e(724), __webpack_require__.e(290), __webpack_require__.e(891)]).then(() => (() => ((__webpack_require__(71891)))));
	},
	"./Detail": () => {
		return Promise.all([__webpack_require__.e(315), __webpack_require__.e(817), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(834), __webpack_require__.e(369), __webpack_require__.e(724), __webpack_require__.e(213)]).then(() => (() => ((__webpack_require__(84213)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});